import { BaseConfig } from '../ServiceConfig';

export interface PPMConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PpmServiceConfigData';
  url: string;
  channel: string;
  terminal: string;
}

export const PPMConfigurationFields: (keyof PPMConfiguration)[] = [
  'url',
  'channel',
  'terminal',
];

export const BlankPPMConfiguration: PPMConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PpmServiceConfigData',
} as PPMConfiguration;
